<ion-header>
  <ion-toolbar mode="md"
               color="dark">
    <ion-title>{{ 'login.sessionTimeoutIn' | transloco }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content fullscreen>
  <div class="h-full flex ion-align-items-center ion-justify-content-center">
    <p><strong>{{countdown}} {{ (countdown > 1) ? ('login.seconds' | transloco) : ('login.second' | transloco) }}</strong></p>
  </div>
</ion-content>
